import { render } from "./ModalAlert.vue?vue&type=template&id=65c1c1f0"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"
script.render = render

export default script